import React from "react";
import PropTypes from "prop-types";

import {getInt} from "../../../../utils/getInt";

import TextField from "@mui/material/TextField/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const StepBeds = (props) => {
    const {formik} = props

    return <Stack direction="column" spacing={3} sx={{mt: 1}}>
        <TextField
            required
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            label="Nome appartamento"
            fullWidth
        />

        <TextField
            required
            name="beds"
            value={formik.values.beds}
            onChange={formik.handleChange}
            error={formik.touched.beds && Boolean(formik.errors.beds)}
            helperText={formik.touched.beds && formik.errors.beds}
            label="Posti letto"
            fullWidth
        />

        <TextField
            required
            name="sofaBeds"
            value={formik.values.sofaBeds}
            onChange={formik.handleChange}
            error={formik.touched.sofaBeds && Boolean(formik.errors.sofaBeds)}
            helperText={formik.touched.sofaBeds && formik.errors.sofaBeds}
            label="Posti divano letto"
            fullWidth
        />

        <TextField
            required
            name="extraBeds"
            value={formik.values.extraBeds}
            onChange={formik.handleChange}
            error={formik.touched.extraBeds && Boolean(formik.errors.extraBeds)}
            helperText={formik.touched.extraBeds && formik.errors.extraBeds}
            label="Posti letto extra"
            fullWidth
        />

        <Typography>
            Numero totale di ospiti: {getInt(formik.values.beds) + getInt(formik.values.sofaBeds) + getInt(formik.values.extraBeds)}
        </Typography>
    </Stack>
}

StepBeds.propTypes = {
    formik: PropTypes.object.isRequired
};

export default StepBeds;